import { __ } from '@wordpress/i18n';
import { Placeholder, Button, Dashicon, Modal } from '@wordpress/components';

import { more } from '@wordpress/icons';

import { MediaUpload, MediaUploadCheck } from '@wordpress/block-editor';
import ImageLoad from './image-load';
const InspectorImageSelector = ( props ) => {
	const { className, value, onChange } = props;

	const removeIcon = ( e ) => {
		e.stopPropagation();
		onChange( {
			id: null,
			url: '',
			alt: '',
		} );
	};

	return (
		<>
			<MediaUploadCheck>
				<MediaUpload
					onSelect={ ( media ) => {
						onChange( {
							id: media.id,
							url: media.url,
							alt: media.alt,
						} );
					} }
					allowedTypes={ [ 'image' ] }
					value={ value?.id }
					render={ ( { open } ) => (
						<Placeholder
							className="border-gray-300 border shadow-none hover:cursor-pointer relative group overflow-hidden"
							onClick={ open }
						>
							{ value?.url && (
								<div className="float-right top-0">
									<div
										className="absolute float-right size-5 top-1.5 right-1.5 rounded-full flex justify-center items-center bg-gray-300"
										onClick={ ( e ) => removeIcon( e ) }
									>
										<Dashicon
											icon="no-alt"
											className="text-white text-base leading-[20px]"
										></Dashicon>
									</div>
								</div>
							) }
							{ value?.url && (
								<ImageLoad
									attachmentId={ value.id }
									attachmentURL={ value.url }
								/>
							) }

							{ ! value?.url && (
								<div className="pb-3 flex justify-center items-center">
									<Dashicon
										icon="plus"
										className="iconblock_icon *:size-8"
									></Dashicon>
								</div>
							) }
							<div className="group-hover:translate-y-0 translate-y-full transition-transform duration-300 absolute change-icon-text bg-gray-300 text-center  bottom-0 left-0 right-0">
								<p>{ __( 'Change Image', 'alpha' ) }</p>
							</div>
						</Placeholder>
					) }
				/>
			</MediaUploadCheck>
		</>
	);
};

export default InspectorImageSelector;
